<template>
  <footer>
    <section class="section footer-section">
      <div class="container">
        <div class="column-wrapper">
          <div class="column logo">
            <v-Icon class="logo" alt="FPS - logo" name="logo-full-white" />
          </div>
          <div class="column double-nav">
            <div class="nav-wrapper">
              <h2 class="column-title">Policies</h2>
              <nav>
                <ul>
                  <li>
                    <router-link to="/terms-of-use"> Terms of Service </router-link>
                  </li>
                  <li>
                    <router-link to="/privacy-policy"> Privacy Policy </router-link>
                  </li>
                  <li>
                    <router-link to="/cookie-policy"> Cookie Policy </router-link>
                  </li>
                  <li>
                    <router-link to="/data-policy"> Data Policy </router-link>
                  </li>
                </ul>
              </nav>
            </div>

            <div class="nav-wrapper">
              <h2 class="column-title">Contact us</h2>
              <nav>
                <ul>
                  <li>
                    <router-link to="/contact"> Contact information </router-link>
                  </li>
                  <li>
                    <router-link to="/contact"> Sales contact </router-link>
                  </li>
                  <li>
                    <router-link to="/press-media"> Press & Media </router-link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="section copyright-bar">
      <div class="container">
        <nav>
          <ul>
            <li>
              <router-link to="/privacy-policy"> Privacy voorwaarden </router-link>
            </li>
            <li>
              <router-link to="/terms-of-use"> Algemene voorwaarden </router-link>
            </li>
          </ul>
        </nav>

        <span class="copy">&copy; {{ new Date().getFullYear() }}</span>
      </div>
    </div>

    <!-- <transition name="fade">
            <ChangeUsernamePopup v-if="globalStore.displayChangeUsernamePopup" />
        </transition>

        <transition name="fade">
            <div class="mini-notice" v-if="globalStore.displayMiniNotice">
                {{ globalStore.displayMiniNotice }}
            </div>
        </transition> -->
  </footer>

  <!-- <LiveChat v-if="isAuthenticated && route.name !== 'NetworkPage'" /> -->
</template>

<script>
import { defineComponent, computed } from 'vue'

// import ChangeUsernamePopup from '@/components/ChangeUsernamePopup/index.vue'
// import LiveChat from '@/components/LiveChat/index.vue'

import { useRoute } from 'vue-router'

import { useAuthenticationData } from '@/composables/useAuthenticationData'

import { useGlobalStore } from '@/stores/global'

export default defineComponent({
  components: {
    // ChangeUsernamePopup,
    // LiveChat
  },
  setup() {
    const route = useRoute()

    const globalStore = useGlobalStore()

    const isAuthenticated = computed(() => useAuthenticationData().data.value.isAuthenticated)

    return {
      globalStore,
      isAuthenticated,
      route
    }
  }
})
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
